import { makeAutoObservable } from "mobx";

const COUNTRY_KEY = "wepurplay_shop_country";
const COUNTRY_TUTORIAL_KEY = "wepurplay_shop_country_tutorial_finished";
const SHOP_FINGER_DEMO_KEY = "wepurplay_shop_finger_demo_finished";

class ShopStore {
  selectedCountry = null;
  isCountryTutorialFinished = false;
  isShopFingerDemoFinished = false;
  isOpen = false;
  card = null;

  constructor() {
    makeAutoObservable(this);
    try {
      this.selectedCountry = localStorage.getItem(COUNTRY_KEY);
      this.isCountryTutorialFinished =
        localStorage.getItem(COUNTRY_TUTORIAL_KEY) === "1";
      this.isShopFingerDemoFinished =
        localStorage.getItem(SHOP_FINGER_DEMO_KEY) === "1";
    } catch (e) {
      this.selectedCountry = null;
    }
  }

  setCountry(code) {
    this.selectedCountry = code;
    try {
      localStorage.setItem(COUNTRY_KEY, code);
    } catch (e) {
      // localStorage write failed (private mode / quota) — keep in-memory only
    }
  }

  markCountryTutorialFinished() {
    this.isCountryTutorialFinished = true;
    try {
      localStorage.setItem(COUNTRY_TUTORIAL_KEY, "1");
    } catch (e) {
      // localStorage write failed — keep in-memory only
    }
  }

  markShopFingerDemoFinished() {
    this.isShopFingerDemoFinished = true;
    try {
      localStorage.setItem(SHOP_FINGER_DEMO_KEY, "1");
    } catch (e) {
      // localStorage write failed — keep in-memory only
    }
  }

  open(card = null) {
    this.card = card;
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
    this.card = null;
  }
}

export const shopStore = new ShopStore();
